import { Route } from 'react-router-dom';
import TasksPage from './pages/TasksPage';

// Módulo cross `tasks` (paridad con agenda/letsmove, 16-jul-2026). El gating por
// módulo lo hace PATH_MODULE ('/dashboard/tasks' → 'tasks') + el menú.
export const TasksRoutes = [
  <Route key="tasks" path="/dashboard/tasks" element={<TasksPage />} />,
];
